import React from 'react';
import { Avatar } from '@mui/material';

const DSAvatar = (props: React.ComponentProps<typeof Avatar>) => {
  return <Avatar {...props} />;
};

export default DSAvatar;
